import { globalComponents } from 'src/types/globalTypes';
import DirectionPage, {
  MainContent,
  SubTitle,
  Img,
  ContentWrapper,
  Annotation,
} from 'src/components/contents/direction/DirectionPage';
import Direction01 from 'src/assets/images/direction/qrCode/qrcode_direction_01.svg';

/**
 * QR code操作說明。
 */
const QRCodeDirection: React.FC = () => {
  // 頁面靜態資料
  const component = globalComponents.T;
  const colorType = component.color;

  const desktopForm = (
    <MainContent>
      <SubTitle>掃描專利或商標實體證書之 QR code</SubTitle>
      <p>您可利用行動裝置掃描實體證書上的 QR code，來直接顯示最新權證資訊。</p>
      <Img src={Direction01} />
    </MainContent>
  );

  return (
    <DirectionPage
      bannerBgImg={component.bgImgResultBanner}
      image={component.hoverImage}
      imgDot={component.bgImgDot}
      bgColor={colorType}
    >
      <ContentWrapper>
        {desktopForm}
        <Annotation>若有任何疑問，請洽客服專線：(02)-8176-9009。</Annotation>
      </ContentWrapper>
    </DirectionPage>
  );
};

export default QRCodeDirection;
